import React from 'react'
import Link from 'next/link'

const RandomCard = ({ icon, title, description, buttonText, buttonUrl }) => {
    return (
        <div className="w-full sm:w-[420px] shadow-lg p-12 border flex flex-col gap-4 text-center justify-center items-center rounded-2xl">
            <div className="bg-violet-400 text-violet-700 text-6xl p-8 rounded-full">
                {icon}
            </div>
            <div className="w-full flex flex-col gap-4">
                <h3 className="text-2xl">{title}</h3>
                <p className="text-gray-600">{description}</p>
                <Link href={buttonUrl} className="w-full text-white bg-violet-600 py-3 px-8 rounded-full cursor-pointer font-semibold hover:opacity-90">{buttonText}</Link>
            </div>
        </div>
    )
}

export default RandomCard
